import { SystemEvent } from '@erp/shared-types';

export const systemEventLabels: Record<SystemEvent, string> = {
  [SystemEvent.EMAIL_INGESTED]: 'Email Ingested',
  [SystemEvent.EMAIL_ROUTED_EMAIL_RULE]: 'Email Routed by Email Rule',
  [SystemEvent.EMAIL_ROUTED_AR_REMITTANCE]: 'Email Routed to AR Remittance',
  [SystemEvent.AP_INVOICE_DRAFT_CREATED]: 'AP Invoice Draft Created',
  [SystemEvent.AP_INVOICE_ACCEPTED]: 'AP Invoice Accepted',
  [SystemEvent.AP_INVOICE_EXCEPTIONS_EVALUATED]:
    'AP Invoice Exceptions Evaluated',
  [SystemEvent.PAYMENT_APPROVED]: 'Payment Approved',
  [SystemEvent.SALES_ORDER_APPROVED]: 'Sales Order Approved',
  [SystemEvent.DRAFT_PURCHASE_ORDER_CREATED]: 'Draft Purchase Order Created',
  [SystemEvent.TASK_CREATED]: 'Task Created',
  [SystemEvent.TASK_STATUS_CHANGED]: 'Task Status Changed',
  [SystemEvent.TASK_COMPLETED]: 'Task Completed',
  [SystemEvent.CREDENTIAL_REJECTED]: 'Credential Rejected',
  [SystemEvent.REBATE_CSV_TRANSFORM_STARTED]: 'Rebate CSV Transform Started',
  [SystemEvent.SPA_REQUEST_SUBMITTED]: 'SPA Request Submitted',
  [SystemEvent.APPROVAL_NEEDED]: 'Approval Needed',
  [SystemEvent.DRAFT_SALES_ORDER_ROUTED]: 'Draft Sales Order Routed',
  [SystemEvent.DRAFT_SALES_ORDER_READY]: 'Draft Sales Order Ready',
  [SystemEvent.DRAFT_SALES_ORDER_UNCLASSIFIED]:
    'Draft Sales Order Unclassified',
  [SystemEvent.DISCOUNT_GROUP_SUBMITTED]: 'Discount Group Submitted',
  [SystemEvent.DISCOUNT_REQUEST_DOCUMENT_ROUTED]: 'Discount Request Routed',
  [SystemEvent.AR_REMITTANCE_DOCUMENT_SUBMITTED]:
    'AR Remittance Document Submitted',
  [SystemEvent.AR_REMITTANCE_PORTAL_FETCH_REQUESTED]:
    'AR Remittance Portal Fetch Requested',
  [SystemEvent.AR_DEPOSIT_FILE_SUBMITTED]: 'AR Deposit File Submitted',
  [SystemEvent.SLACK_WEBHOOK_RECEIVED]: 'Slack Webhook Received',
  [SystemEvent.WORKBOOK_RUN_COMPLETED]: 'Workbook Run Completed',
};

export function getSystemEventLabel(eventType?: string): string {
  if (!eventType) {
    return 'Event';
  }

  if (eventType in systemEventLabels) {
    return systemEventLabels[eventType as SystemEvent];
  }

  return eventType
    .toLowerCase()
    .split('_')
    .map((segment) =>
      segment.length > 0
        ? segment[0].toUpperCase() + segment.slice(1)
        : segment,
    )
    .join(' ');
}
